// SendFormFields.jsx
import React from 'react';
import { Form, Select, InputNumber, Input } from 'antd';
import { validateCurrency } from '../../utils/validation';

const { Option } = Select;

const SendFormFields = () => (
  <>
    <Form.Item
      name="name"
      label="Nome"
      className="select form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Select>
        <Option value="OMNION">Omnion</Option>
        <Option value="SC">SC</Option>
        <Option value="MARKUP">Markup</Option>
        <Option value="BANCO_SC">Banco SC</Option>
      </Select>
    </Form.Item>
    <Form.Item
      name="sendType"
      label="Tipo de disparo"
      className="select form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <Select>
        <Option value="WHATSAPP">WhatsApp</Option>
        <Option value="EMAIL">Email</Option>
        <Option value="SMS">SMS</Option>
      </Select>
    </Form.Item>
    <Form.Item
      name="quantity"
      label="Quantidade"
      className="form-item"
      rules={[{ required: true, message: 'Campo obrigatório!' }]}
    >
      <InputNumber style={{ width: '100%' }} min={1} controls={false} />
    </Form.Item>
    <Form.Item
      name="unitValue"
      label="Valor unitário"
      className="form-item"
      rules={[
        { required: true, message: 'Campo obrigatório!' },
        { validator: validateCurrency },
      ]}
    >
      <Input />
    </Form.Item>
  </>
);

export default SendFormFields;
